import { toastr } from 'react-redux-toastr';
import i18next from 'i18next';
import {
    LOADING_PROCCESS,
    DUPLICATE_MESSAGE,
    VERIFICATION_FAILED
} from '../actions/types';
import { newPanelVersionDetected } from '../actions';
import { updatePanelVersion } from '../helpers/version';

const requestsQueue = [];

export const requestMiddleware = store => next => action => {
    if (action.payload && typeof action.payload.then === 'function') {
        const { type, payload, meta = {} } = action;

        // Prevent from same request to accidently be sent more then once
        if (requestsQueue.indexOf(type) > -1 && !meta.allowRequestDuplication) {
            return next({ type: DUPLICATE_MESSAGE });
        }

        requestsQueue.push(type);

        store.dispatch({ type: LOADING_PROCCESS, payload: true, meta });

        if (meta.dispatchBeforeRequest) {
            store.dispatch(meta.dispatchBeforeRequest());
        }

        return Promise.resolve(payload).then(({ headers, data }) => {
            store.dispatch({ type: LOADING_PROCCESS, payload: false, meta });

            requestsQueue.splice(requestsQueue.indexOf(type), 1);

            store.dispatch({ type: type, payload: data, meta });

            if (meta.onSuccess) {
                meta.onSuccess(data);
            }
            if (meta.dispatchOnSuccess) {
                setTimeout(() => store.dispatch(meta.dispatchOnSuccess(data)), 100);
            }
            if (meta.toastSuccess) {
                toastr.success(i18next.t('general.success'));
            }

            if (headers.version) {
                const currentVersion = localStorage.getItem('version');

                if (!currentVersion) {
                    updatePanelVersion(headers.version);
                } else if (currentVersion !== headers.version) {
                    store.dispatch(newPanelVersionDetected(headers.version));
                }
            }
        }).catch((error) => {
            store.dispatch({ type: LOADING_PROCCESS, payload: false, meta });

            if (meta.dispatchOnError) {
                store.dispatch(meta.dispatchOnError(error));
            }

            requestsQueue.splice(requestsQueue.indexOf(type), 1);

            if (meta.onFailure) {
                meta.onFailure(error);
            } else if (error.response) {
                if (error.response.status === 400) {
                    toastr.error('Bad request', error.response.data);
                } else if (error.response.status === 401) {
                    store.dispatch({ type: VERIFICATION_FAILED });
                    toastr.error('Authentication failed', error.response.data);
                } else if (error.response.status === 500) {
                    toastr.error('Server error', error.response.data);
                } else {
                    toastr.error('Error', 'Something went wrong');
                }
            } else if (error.request) {
                toastr.error('No response', 'Could not reach to server');
            } else {
                toastr.error('Error', error.message);
            }
        });
    }

    return next(action);
};
